<div class="container p-4 px-xl-0 registration-container">
  <h1 class="text-uppercase mb-2">{{ "registration.header" | translate }}</h1>
  <p class="mb-4">{{ "registration.headerText" | translate }}</p>

  <!-- Registration Form  -->
  <div class="mb-3">
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="radio" id="radioPrivate" (change)="commercial = !commercial"
        checked>
      <label class="form-check-label" for="radioPrivate">
        {{ "registration.private" | translate }}
      </label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="radio" id="radioCommercial" [checked]="commercial"
        (change)="commercial = !commercial">
      <label class="form-check-label" for="radioCommercial">
        {{ "registration.commercial" | translate }}

      </label>
    </div>
  </div>
  <div class="row gap-3 pb-4">
    <div class="col-lg-60 row d-flex align-items-center">
      <form [formGroup]="registrationForm" class="row" (ngSubmit)="onSubmit(registrationForm)">
        <div class="mb-3">
          <div class="input-group">
            <span class="form-floating">
              <input type="email" class="form-control" id="email" placeholder="name@example.com" formControlName="email"
                [ngClass]="showRequired ? registrationForm.controls['email'].invalid? 'is-invalid':'' : ''">
              <label for="email">{{ "form.email.placeholder" | translate}} *</label>
            </span>
          </div>
          @if (showRequired) {
            <div>
              @if (registrationForm.controls['email'].hasError('required')) {
                <label class="text-danger">
                  {{ "form.email.error.required" | translate }}
                </label>
              }
              @if (registrationForm.controls['email'].hasError('email')) {
                <label class="text-danger">
                  {{ "form.email.error.pattern" | translate }}
                </label>
              }
              @if (registrationForm.controls['email'].hasError('emailAlreadyInUse')) {
                <label class="text-danger">
                  {{ "form.email.error.emailAlreadyInUse" | translate }}
                </label>
              }
            </div>
          }
        </div>
        <div class="mb-3">
          <div class="input-group">
            <span class="form-floating">
              <input id="password"
                [ngClass]="showRequired ? registrationForm.controls['password'].invalid? 'is-invalid':'' : ''"
                [type]="passwordTextType ? 'text' : 'password'" formControlName="password" class="form-control"
                placeholder="placeholder" />
              <label for="password">{{ "form.password.placeholder" | translate }} *</label>
            </span>
            <span class="cursor-pointer input-group-text" (click)="togglePassword()">
              <i [ngClass]="{
                          'bi-eye-slash': !passwordTextType,
                          'bi-eye': passwordTextType
                      }"></i>
            </span>
          </div>
          @if (showRequired) {
            <div>
              @if (registrationForm.controls['password'].hasError('required')) {
                <label class="text-danger">
                  {{ "form.password.error.required" | translate }}
                </label>
              }
            </div>
          }
          @if (this.strength!='grey') {
            <div class="row">
              <!-- Password Strength -->
              <div class="col-120 d-flex justify-content-center" [style.background-color]="strength" style="color: white">
                <b>{{strengthText}}</b>
              </div>
            </div>
          }
          @if (registrationForm.controls['password'].value) {
            <div class="row d-flex align-items-baseline pt-3">
              <!-- Password Validation -->
              <div class="d-flex flex-row mb-1">
                <div class="col-15 col-lg-5"
                  [ngClass]="registrationForm.controls['password'].hasError('required') || registrationForm.controls['password'].hasError('minlength')  ? 'text-danger' : 'text-success'">
                  <i class="material-icons password-icon">
                    {{ registrationForm.controls['password'].hasError('required') ||
                    registrationForm.controls['password'].hasError('minlength') ? 'clear ' : 'done ' }}
                  </i>
                </div>
                <div class="col-100 col-lg-115 align-self-center">
                  {{'validation.amount' | translate }}
                </div>
              </div>
              <div class="d-flex flex-row mb-1">
                <div class="col-15 col-lg-5"
                  [ngClass]="registrationForm.controls['password'].hasError('required') || registrationForm.controls['password'].hasError('hasSmallCase') || registrationForm.controls['password'].hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'">
                  <i class="material-icons password-icon">
                    {{ registrationForm.controls['password'].hasError('required') ||
                    registrationForm.controls['password'].hasError('hasSmallCase') ||
                    registrationForm.controls['password'].hasError('hasCapitalCase') ? 'clear' :'done' }}
                  </i>
                </div>
                <div class="col-100 col-lg-115 align-self-center">
                  {{'validation.upperLowerCase' | translate }}
                </div>
              </div>
              <div class="d-flex flex-row mb-1">
                <div class="col-15 col-lg-5"
                  [ngClass]="registrationForm.controls['password'].hasError('required') || registrationForm.controls['password'].hasError('hasNumber')  ? 'text-danger'  : 'text-success'">
                  <i class="material-icons password-icon">
                    {{ registrationForm.controls['password'].hasError('required') ||
                    registrationForm.controls['password'].hasError('hasNumber') ? 'clear' : 'done' }}
                  </i>
                </div>
                <div class="col-100 col-lg-115 align-self-center">
                  {{'validation.numbers' | translate }}
                </div>
              </div>
              <div class="d-flex flex-row mb-1">
                <div class="col-15 col-lg-5"
                  [ngClass]="registrationForm.controls['password'].hasError('required') || registrationForm.controls['password'].hasError('hasSpecialCharacters') ? 'text-danger' : 'text-success'">
                  <i class="material-icons password-icon">
                    {{ registrationForm.controls['password'].hasError('required') ||
                    registrationForm.controls['password'].hasError('hasSpecialCharacters') ? 'clear' : 'done' }}
                  </i>
                </div>
                <div class="col-100 col-lg-115 align-self-center">
                  {{'validation.special' | translate }}
                </div>
              </div>
            </div>
          }
        </div>
        <div class="mb-3">
          <div class="input-group">
            <span class="form-floating">
              <input id="repeatPassword"
                [ngClass]="showRequired ? registrationForm.controls['repeatPassword'].invalid? 'is-invalid':'' : ''"
                [type]="repaetPasswordTextType ? 'text' : 'password'" formControlName="repeatPassword"
                class="form-control" placeholder="password" />
              <label for="repeatPassword">
                {{'form.repeatPassword.placeholder' | translate }} *
              </label>
            </span>
            <span class="cursor-pointer input-group-text" (click)="toggleNewRepaetPassword()">
              <i [ngClass]="{
                        'bi-eye-slash': !repaetPasswordTextType,
                        'bi-eye': repaetPasswordTextType
                      }"></i>
            </span>
          </div>
          @if (showRequired) {
            <div>
              @if (registrationForm.controls['repeatPassword'].hasError('required')) {
                <label class="text-danger">
                  {{ "form.repeatPassword.error.required" | translate }}
                </label>
              }
              @if (registrationForm.controls['repeatPassword'].hasError('NoPassswordMatch')) {
                <label class="text-danger">
                  {{ "form.repeatPassword.error.match" | translate }}
                </label>
              }
            </div>
          }
        </div>
        <div class="form-check mb-2">
          <input class="form-check-input" type="checkbox" value="" id="dataProtectionCheck"
            formControlName="dataProtectionCheck"
            [ngClass]="showRequired ? registrationForm.controls['dataProtectionCheck'].invalid? 'is-invalid':'' : ''">
          <label class="form-check-label" for="dataProtectionCheck">
            <div [innerHTML]="'registration.checkbox.dataRegulation' | translate"></div>
          </label>
        </div>
        @if ('registration.newsletter' | feature) {
          <div class="form-check mb-3">
            <input  formControlName="newsletterCheck" class="form-check-input" type="checkbox" value="" id="newsletterCheck">
            <label class="form-check-label" for="newsletterCheck">
              <div [innerHTML]="'registration.checkbox.newsletter' | translate"></div>
            </label>
          </div>
        }
        <div class="pt-3">
          @if (showToastError) {
            <ngb-toast class="bg-danger text-light justify-content-center mb-4" [autohide]="true" [animation]="true" [delay]=3000 (hidden)="onToastErrorHide()">
              {{ "registration.saveError" | translate }}
            </ngb-toast>
          }
          <button class="btn btn-primary col-120 col-lg-40" type="submit" >
            @if (loading) {
              <div>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{'generic.loading' | translate }}
              </div>
            } @else {
              <div>
                {{'registration.createAccount' | translate }}
              </div>
            }
          </button>
        </div>
        <div class="d-none">
          <re-captcha
            #captchaRef
            (resolved)="resolved($event,registrationForm)"
            (errored)="onError($event)"
            errorMode="handled"
            size="invisible"
          ></re-captcha>
        </div>
      </form>
    </div>

    <!-- Divider Desktop -->
    @if (!backToApp) {
      <div class="col-lg-20 align-items-start justify-content-center d-none d-lg-flex registration-form-divider">
        <div class="row">
          <div class="vr mx-auto"></div>
          <p class="m-0">{{'registration.or' | translate }}</p>
          <div class="vr mx-auto"></div>
        </div>
      </div>
    }
    <!-- Divider Mobile -->
    @if (!backToApp) {
      <div class="col-120 align-items-start justify-content-center d-flex d-lg-none">
        <p class="divider-text"><span>{{'registration.or' | translate }}</span></p>
      </div>
    }

    <!-- Login Buttons -->
    @if (!backToApp) {
      <div class="col-lg-35 d-flex gap-2 flex-column pb-3 pb-lg-0">
        <div class="d-flex gap-2 align-items-center">
          <button class="btn d-flex w-100 btn-registration" [disabled]="loading" (click)="login(loginHints.Google)">
            @if (loading) {
              <div>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{'generic.loading' | translate }}
              </div>
            } @else {
              <div class="flex-shrink-0 col-30">
                <img src="registration/assets/icon/Google.png">
              </div>
              <div class="flex-grow-1 col-90">
                {{'registration.googleButton' | translate }}
              </div>
            }
          </button>
        </div>
        <div class="d-flex gap-2 align-items-center">
          <button class="btn d-flex w-100 btn-registration" [disabled]="loading" (click)="login(loginHints.Facebook)">
            @if (loading) {
              <div>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{'generic.loading' | translate }}
              </div>
            } @else {
              <div class="flex-shrink-0 col-30">
                <img src="registration/assets/icon/Facebook.png">
              </div>
              <div class="flex-grow-1 col-90">
                {{'registration.facebookButton' | translate }}
              </div>
            }
          </button>
        </div>
        <div class="d-flex gap-2 align-items-center">
          <button class="btn d-flex w-100 btn-registration" [disabled]="loading" (click)="login(loginHints.Apple)">
            @if (loading) {
              <div>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{'generic.loading' | translate }}
              </div>
            } @else {
              <div class="flex-shrink-0 col-30">
                <img src="registration/assets/icon/Apple.png">
              </div>
              <div class="flex-grow-1 col-90">
                {{'registration.appleButton' | translate }}
              </div>
            }
          </button>
        </div>
        <div class="d-flex gap-2 align-items-center">
          <button class="btn d-flex w-100 btn-registration" (click)="login(loginHints.Empty)">
            @if (loading) {
              <div>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{'generic.loading' | translate }}
              </div>
            } @else {
              <div class="flex-shrink-0 col-30">
                <img src="registration/assets/icon/Branding.svg">
              </div>
              <div class="flex-grow-1 col-90">
                {{'registration.kaercherButton' | translate }}
              </div>
            }
          </button>
        </div>
      </div>
    }
  </div>
  <p class="text-center text-lg-start">
    {{'registration.text.alreadyHaveAccount' | translate }}
    <a  (click)="login(loginHints.Empty)" class="cursor-pointer">
      {{'registration.text.login' | translate }}

    </a>
  </p>
</div>
